import { useState } from "react";
import { X } from "lucide-react";

export const AnnouncementBar = () => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] overflow-hidden"
      style={{ background: "#1a1a1a", borderBottom: "1px solid rgba(255,255,255,0.08)" }}
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: "linear-gradient(90deg, transparent 0%, rgba(124,58,237,0.08) 50%, transparent 100%)",
          animation: "shimmer 3s ease-in-out infinite",
        }}
      />
      <style>{`@keyframes shimmer { 0% { transform: translateX(-100%); } 100% { transform: translateX(100%); } }`}</style>

      <div className="container mx-auto px-4 py-2 flex items-center justify-center gap-3 text-xs sm:text-sm font-medium text-white relative">
        <span>🔥 Founding Member Pricing — Lock In Your Rate Before We Hit 500 Users — <strong style={{ color: "#FAB505" }}>147 spots remaining</strong></span>
        <button
          onClick={() => setDismissed(true)}
          className="absolute right-3 p-1 hover:bg-white/10 rounded transition-colors text-white"
          aria-label="Dismiss announcement"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};
